// Dropdowns
const purchaseDropdowns = document.querySelectorAll('.purchase-process-dropdown.is-radio');

purchaseDropdowns.forEach((purchaseDropdown) => {
  const parent = purchaseDropdown.closest('.purchase-process-dropdowns__item');
  const otherDropdowns = parent.querySelectorAll('.purchase-process-dropdown.is-dropdown');
  const headerInput = purchaseDropdown.querySelector('.purchase-process-dropdown__header input');

  const checkItem = (itemParent) => {
    const dropItems = itemParent.querySelector('.purchase-process-dropdown__item:not([hidden])');
    if (dropItems) {
      dropItems.querySelector('input').checked = true;
    }
  };

  headerInput.addEventListener('change', (ev) => {
    otherDropdowns.forEach((otherDropdown) => {
      const dropContent = otherDropdown.querySelector('.purchase-process-dropdown__drop');
      slideUp(dropContent, 300, 'none');
      otherDropdown.classList.remove('is-open');
      checkItem(dropContent, false);
    });

    const dropdownParent = ev.target.closest('.purchase-process-dropdown.is-dropdown');
    if (dropdownParent) {
      const dropdown = dropdownParent.querySelector('.purchase-process-dropdown__drop');

      if (ev.currentTarget.checked) {
        checkItem(dropdown, true);
        setTimeout(() => {
          dropdownParent.classList.add('is-open');
          slideDown(dropdown, 300, 'flex');
        }, 300);
      }
    }
  });
});

// Check when inputs failed
const observeInputFail = () => {
  const dropdownInputs = document.querySelectorAll('.input-group .mod-input');

  const observer = new MutationObserver((mutationsList) => {
    mutationsList.forEach((mutation) => {
      if (
        mutation.type === 'attributes' &&
        mutation.attributeName === 'class' &&
        mutation.target.classList.contains('is-validation-failed')
      ) {
        mutation.target.closest('.input-group').classList.add('is-failed');
      }
    });
  });

  dropdownInputs.forEach((input) => {
    observer.observe(input, { attributes: true });
  });
};

observeInputFail();
